import { toast } from "react-toastify";
import { apicall } from "../../services/api";
import { media_actions } from "./actionTypes";

// Upload Media (Image/Video)
export const uploadMedia = (payload) => async (dispatch) => {
  dispatch({ type: media_actions.UPLOAD_MEDIA_REQUEST });
  try {
    const response = await apicall("resource-content/uploadMedia", "post", payload, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    dispatch({ type: media_actions.UPLOAD_MEDIA_SUCCESS, payload: response.data });
    toast.success(response?.data?.message);
    return { payload: response.data }; 
  } catch (error) {
    dispatch({ type: media_actions.UPLOAD_MEDIA_FAILURE, error: error.message });
    throw error;
  }
};

// Update Media
export const updateMedia = (payload) => async (dispatch) => {
  dispatch({ type: media_actions.UPDATE_MEDIA_REQUEST });
  try {
    const response = await apicall("resource-content/updateMedia", "patch", payload, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    dispatch({ type: media_actions.UPDATE_MEDIA_SUCCESS, payload: response.data });
    toast.success("Media updated successfully!");
  } catch (error) {
    dispatch({ type: media_actions.UPDATE_MEDIA_FAILURE, error: error.response?.data || error.message });
    toast.error("Media update failed.");
  }
};
